<template>
  <div>
    <el-dialog
      width="fit-content"
      class="customDialog dialog k3p56gu8"
      title="导入kml"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="exit"
      v-if="showImportkml"
    >
      <el-form
        :model="params"
        :rules="rules"
        ref="form"
        class="form"
        label-width="auto"
        label-position="left"
        label-suffix="："
      >
        <el-row>
          <el-col :span="12">
            <el-form-item prop="layerId" label="所属图层">
              <el-select v-model="params.layerId" v-el-form-item-blur-validate:layerId placeholder="请选择">
                <el-option
                  v-for="item in layers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="coordinateSystem" label="坐标系">
              <el-select v-model="params.coordinateSystem" placeholder="请选择">
                <el-option
                  v-for="item in CoordinateSystems"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="parsing" v-if="parsing">
            <el-progress
              :width="58"
              class="progress lp3eaki"
              type="circle"
              :percentage="percentage"
              :format="(val) => `${val.toFixed()}%`"
            ></el-progress>
            <div class="upload-text font-size-14">解析中...</div>
          </div>
          <app-upload-drag
            :disabled="!params.layerId"
            accept=".kml"
            :before-upload="beforeUpload"
            :http-request="httpRequest"
            :show-file-list="false"
            v-else
          >
            <template slot="text">
              <div class="upload-text">上传kml文件</div>
            </template>
            <template slot="tip">
              <div class="upload-tip">
                当前上传的数据为{{ tips[importkmlType] }}类型
              </div>
            </template>
          </app-upload-drag>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <!-- <el-button type="primary" @click="isShow = false">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog
      width="fit-content"
      class="customDialog dialog k3p56gu8"
      title="数据确认"
      :visible.sync="isShow2"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      @closed="exit"
    >
      <el-table
        class="table aw"
        :data="tableData"
        :max-height="560"
        v-el-table-infinite-scroll="loadMore"
      >
        <el-table-column type="index" label="序号" width="50">
          <template v-slot="{ $index }">
            <span style="color: #999999">{{ $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :formatter="(row, column, cellValue)=>cellValue||'无'" prop="name" label="标注名称">
        </el-table-column>
        <template slot="empty">
          <Empty></Empty>
        </template>
      </el-table>
      <div slot="footer" class="footer">
        <span class="desc">导入共计<span class="total"> {{ originalTableData.length }} </span>条数据</span>
        <el-button @click="isShow2 = false;">取 消</el-button>
        <el-button
          type="primary"
          @click="ImportKmlData"
          :disabled="originalTableData.length === 0"
          :loading="importLoading"
          class="import-btn"
          >确认导入</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AppUploadDrag from '@/components/app-upload-drag.vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { CoordinateSystems2 as CoordinateSystems } from '@/configs/constants.js'
import toGeoJSON from '@mapbox/togeojson'
import * as api from '@/api/marker.js'
import coordtransform from 'coordtransform'

export default {
  components: {
    AppUploadDrag
  },
  data () {
    return {
      page: 0,
      isShow: true,
      // 数据确认
      isShow2: false,
      // 解析中
      parsing: false,
      /**
       * 数据导入加载状态
       */
      importLoading: false,
      // 解析进度值
      percentage: 0,
      params: {
        // 选中的图层名称
        layerId: undefined,
        // 选中的坐标系
        coordinateSystem: CoordinateSystems[0].value
      },
      rules: {
        layerId: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        coordinateSystem: [
          { required: true, message: '请选择', trigger: 'blur' }
        ]
      },
      tips: {
        point: '点',
        polyline: '线',
        polygon: '面'
      },
      mapping: {
        point: 'POINT',
        polyline: 'LINE',
        polygon: 'PLANE'
      },
      CoordinateSystems,
      // 标注列表
      originalTableData: []
    }
  },
  computed: {
    ...mapGetters(['showImportkml', 'importkmlType', 'layerList', '_layerId']),
    layers () {
      const type = this.mapping[this.importkmlType]
      return this.layerList.filter((p) => p.type === type).filter((p) => p.module !== 'sppuc')
    },
    tableData () {
      return _.slice(this.originalTableData, 0, (this.page + 1) * 20)
    }
  },
  watch: {
    showImportkml (val) {
      if (val) {
        this.params.layerId = _.find(this.layers, { id: this._layerId })?.id
      }
    }
  },
  methods: {
    loadMore () {
      if (this.tableData.length < this.originalTableData.length) this.page++
    },
    async exit () {
      this.$store.commit('SELECT_IMPORTKML', false)
      await this.$nextTick()
      this.isShow = true
    },
    // 限制上传的文件类型
    beforeUpload (file) {
      if (!/\.kml/i.test(file.name)) {
        this.$message.error('仅支持上传kml类型的文件')
        return false
      }
      return true
    },
    // 覆盖默认的上传行为，前端解析kml
    async httpRequest ({ file, onSuccess, onError }) {
      this.parsing = true
      const onPercentage = this.onPercentage // _.debounce(this.onPercentage, 15)
      onPercentage(0, 100)
      const xmlString = await file.text()
      onPercentage(50, 100)
      try {
        const xml = new DOMParser().parseFromString(
          xmlString,
          'application/xml'
        )
        const s = toGeoJSON.kml(xml)
        onPercentage(100, 100)
        onSuccess && onSuccess(file)
        await new Promise((resolve) => setTimeout(resolve, 1000))
        this.parsing = false
        this.readTableData(s)
        this.isShow2 = true
        this.exit()
      } catch (e) {
        this.$message.error(e.message)
        onError && onError(e)
      }
    },
    onPercentage (current, total) {
      this.percentage = (current / total) * 100
    },
    readTableData ({ features }) {
      // console.log(features)
      this.page = 0
      const mapping = {
        point: /^point$/i,
        polyline: /^linestring$/i,
        polygon: /^polygon$/i
      }
      const mapping2 = {
        point: '4',
        polyline: '2',
        polygon: '3'
      }
      const { coordinateSystem } = this.params
      // 转换方法
      const transform = function (coordinates) {
        let result
        switch (coordinateSystem) {
          case 'GAODE':
            result = _.chain(coordinates)
              .thru(([lng, lat, alt = 0]) => {
                return [...coordtransform.gcj02towgs84(lng, lat), alt]
              })
              .value()
            break
          case 'BAIDU':
            result = _.chain(coordinates)
              .thru(([lng, lat, alt = 0]) => {
                return [...coordtransform.bd09togcj02(lng, lat), alt]
              })
              .thru(([lng, lat, alt = 0]) => {
                return [...coordtransform.gcj02towgs84(lng, lat), alt]
              })
              .value()
            break
          default:
            result = _.chain(coordinates)
              .thru(([lng, lat, alt = 0]) => {
                return [lng, lat, alt]
              })
              .value()
            break
        }
        return result
      }
      const reg = mapping[this.importkmlType]
      // eslint-disable-next-line camelcase
      const draw_mode_ = mapping2[this.importkmlType]
      const filters = _.filter(features, (p) => reg.test(p.geometry.type)).map(
        (p) => {
          // 坐标系预处理
          if (/^point$/i.test(p.geometry.type)) {
            p.geometry.coordinates = transform(p.geometry.coordinates)
          } else if (/^linestring$/i.test(p.geometry.type)) {
            p.geometry.coordinates = p.geometry.coordinates.map(p2 => transform(p2))
          } else {
            p.geometry.coordinates[0] = p.geometry.coordinates[0].map(p2 => transform(p2))
          }

          const { properties, ...p2 } = p

          const coordinates = _.flattenDeep(p.geometry.coordinates)
          const heights = []
          for (let i = 0; i < coordinates.length; i += 3) {
            heights.push(coordinates[i + 2])
          }
          const name = properties.name || ''
          return {
            ...p2,
            properties: { name, draw_mode_, height_: JSON.stringify(heights) },
            name
          }
        }
      )
      this.originalTableData = filters
    },
    async ImportKmlData () {
      this.importLoading = true
      try {
        await api.kmlImport(this.params.layerId, this.originalTableData)
        this.$message.success()
        this.isShow2 = false
        this.$emit('updateLayer')
        this.exit()
      } catch (e) {
        this.$message.error(e.message)
        throw e
      } finally {
        this.importLoading = false
      }
    }
  },
  mounted () {}
}
</script>

<style lang="scss">
.dialog.k3p56gu8 {
  .el-dialog__body {
    padding: 16px;
  }
  .el-dialog__footer {
    padding-bottom: 16px;
  }
}
.progress.lp3eaki {
  .el-progress-circle {
    --el-progress-circle__track-stroke: rgba(255, 255, 255, 0.1);
    --el-progress-circle__path-stroke: rgba(0, 164, 240, 1);
    .el-progress-circle__track {
      stroke: var(--el-progress-circle__track-stroke);
    }
    .el-progress-circle__path {
      stroke: var(--el-progress-circle__path-stroke);
    }
  }
  .el-progress__text {
    font-size: 14px !important;
    color: #fff;
  }
}
</style>

<style lang="scss" scoped>
.form {
  width: 516px;
}
.table {
  width: 560px;
}

.upload-text,
.upload-tip {
  font-size: 12px;
  color: #fff;
  &.font-size-14 {
    font-size: 14px;
  }
}
.upload-tip {
  color: rgba(255, 255, 255, 0.4);
}

// 解析中样式
.parsing {
  border-radius: 6px;
  border: 1px dashed #0177ae;
  height: 120px;
  background-color: rgba(0, 164, 240, 0.1);
}

.progress {
  width: 56px;
  height: 56px;
  margin-top: 21px;
}

.el-form-item {
  margin-bottom: 16px;
}

.footer {
  display: flex;
  align-items: center;
  > span:first-child {
    flex: 1;
    text-align: left;
  }
}

.import-btn {
  width: auto !important;
  min-width: 80px;
}

.desc {
  color: #999999;
}
.total {
  color: #fff;
  font-size: 16px;
}
</style>
